import { Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";


const PageNotFound = () => {
 
  return (
 
     <>Page not found</>

  );
};

export default PageNotFound;